<script setup>
import { computed } from 'vue';
import { useLocale } from 'shared/composables/useLocale';

const { resolvedLocale } = useLocale();
const calendarWeeks = computed(() =>
  Array.from({ length: 7 }, (_, index) => ({
    id: index + 1,
    label: new Intl.DateTimeFormat(resolvedLocale.value, {
      weekday: 'narrow',
    }).format(new Date(2024, 0, index + 1)),
  }))
);
</script>

<template>
  <div class="w-full max-w-md mx-auto grid grid-cols-7 gap-1 sm:gap-2">
    <div
      v-for="day in calendarWeeks"
      :key="day.id"
      class="flex items-center justify-center font-medium text-sm min-w-0 sm:w-9 h-7 py-1.5 px-2"
    >
      {{ day.label }}
    </div>
  </div>
</template>
